import styled from 'styled-components';

export const COMMANDE_RESPONSIVE_MAX_WIDTH_PX = 768;

export const commandeResponsiveMediaQuery = `(max-width: ${COMMANDE_RESPONSIVE_MAX_WIDTH_PX}px)`;

export const $Page = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 1400px;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const $PanelInner = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;
